// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export{black:#000;white:#fff}\n", "",{"version":3,"sources":["/home/webapp/django-projects/art-attack/frontend/src/css/colors.scss"],"names":[],"mappings":"AAIA,QACI,UALQ,CAMR,UALQ","file":"App.scss","sourcesContent":["$black: #000;\n$white: #FFF;\n\n// Export for use in React components\n:export {\n    black: $black;\n    white: $white;\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
